export const validateNI = (niNumber: string) => {
	try {
		if (!niNumber) {
			return false;
		}
		const cleanNI = niNumber.trim?.()?.toUpperCase();
		if (!cleanNI) {
			return false;
		}
		const regex = /^[A-Z]{2}[0-9]{6}[A-Z]{1}$/;
		return regex.test(cleanNI);
	} catch (error) {
		return false;
	}
};
